export default __webpack_public_path__ + "static/media/Righteous-Regular.fd011047.ttf";